import { createAction } from 'redux-actions';
import { authUpload } from '../AuthFetch';

export const forwardToSetMaintainCaseReqParam = createAction('SET_MAINTAIN_CASE_REQ_PARAM');

export const forwardToCreateMaintenanceCase = (orderId, prefix, initNo, org, unit, note, uploadFile, user) => (
  (dispatch) => {
    let formData = new FormData();
    formData.append('uploadfile', uploadFile);
    formData.append('orderId', orderId);
    formData.append('note', note);
    formData.append('prefix', prefix);
    formData.append('initNo', initNo);
    formData.append('org', org);
    formData.append('unit', unit);
    formData.append('user', user);

    dispatch({
      type: 'DISPLAY_MAINTENANCE_CASE_UPLOADING'
    });


    let url = '/maintenance/orders/uploadFile';
    authUpload('POST', url, formData, (json) => {
      dispatch({
        type: 'COMPLETE_UPLOAD_MAINTENANCE_CASE_DATA',
        payload: json
      });
    });

  }
);

export const forwardToCreateMaintenanceCaseWithSerial = (orderId, note, receivedDate, returnDate, uploadFile, user) => (
  (dispatch) => {
    let formData = new FormData();
    formData.append('uploadfile', uploadFile);
    formData.append('orderId', orderId);
    formData.append('note', note);
    formData.append('receivedDate', receivedDate);
    formData.append('returnDate', returnDate);
    formData.append('user', user);

    dispatch({
      type: 'DISPLAY_MAINTENANCE_CASE_UPLOADING'
    });

    let url = '/maintenance/orders/uploadSerFile';
    authUpload('POST', url, formData, (json) => {
      dispatch({
        type: 'COMPLETE_UPLOAD_MAINTENANCE_CASE_DATA',
        payload: json
      });
    });

  }
);

export const forwardToClearMaintenancePageState = () => (
  (dispatch) => {
    dispatch({
      type: 'CLEAR_MAINTENANCE_PAGE_STATE'
    });
  }
);



// WEBPACK FOOTER //
// ./src/actions/addMaintenanceCaseActions.js